import { render, staticRenderFns } from "./LinkGroups.vue?vue&type=template&id=5e5ec334&scoped=true"
import script from "./LinkGroups.vue?vue&type=script&lang=js"
export * from "./LinkGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ec334",
  null
  
)

export default component.exports